<template>
  <span>
    <span>
      <el-button icon="el-icon-refresh" type="default" @click="dialogFormVisible = true">
        同步售后单
      </el-button>
    </span>
    <div>
      <el-dialog title="同步售后单" :visible.sync="dialogFormVisible" @open="handleOpen">
        <el-form :model="form">
          <el-form-item label="订单号" :label-width="formLabelWidth">
            <el-input v-model="form.orderId"
                      placeholder="请输入抖音订单号"
                      autocomplete="off"
                      clearable
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogFormVisible = false">取 消</el-button>
          <el-button type="primary" @click="doSync">同 步</el-button>
        </div>
      </el-dialog>
    </div>
  </span>
</template>

<script>
import { Loading } from 'element-ui'
import afterSaleApi from "~/request/afterSaleApi";
export default {
  name: "AfterSaleSyncComponent",
  data() {
    return {
      dialogFormVisible: false,
      form: {},
      formLabelWidth: '120px',
      loadingOptions: {
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      }
    }
  },
  methods: {
    handleOpen() {
      this.form = {}
    },

    doSync() {
      const {orderId} = this.form
      if (!orderId) {
        this.$message.warning('请输入抖音订单号！')
        return
      }
      const loading = Loading.service(this.loadingOptions)
      afterSaleApi.syncAfterSaleOrder(orderId).then(() => {
        this.$message.success('同步完成！')
      }).catch(err => {
        this.$message.error(err.message)
      }).finally(() => {
        loading.close()
      })
    }
  }
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/AfterSaleOrderSyncBtn/index.vue